export const selector = (data) => {
  return data?.data;
};
